/**
 * BrandWordmark — the CoLiviq lockup, as the logo file rather than type.
 *
 * The brand is a lowercase "coliviq" wordmark in the brand-kit dark green
 * (#092E2C); every surface that used to pair the house icon with a typeset
 * "CoLiviq" now shows this one image instead, so the mark can't drift per
 * screen. Sized by height only — the SVG's viewBox is cropped to its ink, so a
 * height IS the wordmark's height and there is no built-in margin to eat into
 * the layout (the brand kit's clear-space rule is the surrounding gap's job).
 *
 * Not for operator-branded surfaces: a white-label operator must never see the
 * CoLiviq mark (see useOperatorBranding), so those keep their own name as text.
 */
export function BrandWordmark({
  className = "h-5 w-auto",
  title,
}: {
  className?: string;
  title?: string;
}) {
  return (
    <img
      src="/coliviq-logo.svg"
      alt="coliviq"
      title={title}
      className={`select-none object-contain ${className}`}
      draggable={false}
    />
  );
}
